module.exports = __webpack_public_path__ + "img/er_phon.dc41e833.png";